export default __webpack_public_path__ + "static/media/vardan_m.da2ee636.jpg";